import { computed, defineComponent, h, toRefs } from 'vue';
import { ItemProps } from '@/ui/components/inspectionReport/types';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
import { n } from '@/ui/i18n/i18n';
import { getDecimalPercentage, isNumberDefined } from '@/ui/helpers';
import { useItem } from '@/ui/components/inspectionReport/useItem';

export const Section = defineComponent<ItemProps>({
  name: 'Section',
  props: ['item'],
  setup(props) {
    const { resource, getSubItems } = useInspectionReport();
    const { item } = toRefs(props);
    const { title } = useItem(item);

    const template = computed(() => resource.value?.template);
    const shouldDisplayScore = computed(() =>
      template.value?.display_score && isNumberDefined(props.item.percentage));

    return function render() {
      return !props.item.repeat
        ? h('div', [
          h('table', { class: 'inspection-report__table-section' }, [
            h('tr', [
              h('td', [
                h('div', { class: 'flex avoid-page-break' }, [
                  h('span', { class: 'inspection-report__table-section-title' }, [title.value]),
                  h('div', { class: 'text-right' }, [
                    shouldDisplayScore.value
                      ? h('span', { class: 'inspection-report__table-section-result' }, [
                        n(getDecimalPercentage(props.item.percentage!), 'scorePercentage'),
                      ])
                      : null,
                  ]),
                ]),
              ]),
            ]),
          ]),
          h('div', { class: 'inspection-report__section-content' }, [
            props.item.items ? getSubItems(props.item.items) : [],
          ]),
        ])
        : null;
    };
  },
});
